module.exports = __webpack_public_path__ + "img/mt_hx.a3cb7109.png";